module.exports = __webpack_public_path__ + "img/up_arrow_pink_icon.6ffbe185.svg";